import { __translate } from '../../language/translate.js';
import { formatNumberForLocale } from '../../helpers/helpers.js';
import { validate_single_input } from '../../helpers/validators/validate.js';
import { getBraintreeClientToken, getPaymentData, subscribeWithPayment } from '../../services/payment.service.js';
import { feedbackProcessingDialog, killProcessingDialog, wadialog } from '../dialogs/dialog.module.js';
export function payment_tokenize(token, method) {

  var user_token;// = 'sandbox_hc527vt6_73hbkzvkqr5z4m3d'; 

  return new Promise(function (resolve, reject) {

    user_token = token;

    if (method == 'recent') {
      resolve('somepayload');
      return true;
    }

    braintree.client.create({
      authorization: user_token
    },
      function (createErr, clientInstance) {
        if (createErr) { reject(createErr); return; }
        var data = {};
        var endpoint = '';
        if (method == 'creditcard') {
          data = {
            creditCard: {
              number: $('#pay-cc-number').val(),
              cvv: $('#pay-cc-cvv').val(),
              expirationDate: $('#datepicker').val()
            },
            options: {
              validate: false
            }
          };
          endpoint = 'payment_methods/credit_cards';
        }
        clientInstance.request({
          endpoint: endpoint,
          method: 'post',
          data: data
        },
          function (requestErr, response) {
            if (requestErr) { reject(requestErr); return false; }
            resolve(response.creditCards[0].nonce);
            return true;
          });
      });
  });
}

export function openPaymentDialog() {
  getPaymentData().then(function(res) {
    const findPlan = (code) => res.plans.find((plan) => plan.code === code);
    const planNames = { free: I18n['payment_free_plan'], basic: I18n['payment_pay_per_asset_plan'], unlimited: I18n['payment_unlimited_plan'] };
    const currencySymbol = res.currency.toCurrencySymbol();
    const formatPrice = (price) => currencySymbol + formatNumberForLocale(Number(price).toFixed(2));
    const parseData = {
      currency: res.currency,
      test_payment: res.test_payment === true,
      recentPayment: res.paymenttype === 'paypal' ? 'PayPal, ' + res.paypal_email : res.card_type + ', ' + res.expiration_month + '/' + res.expiration_year + ', **** ' + res.last_4,
      recentdisplay: ['creditcard', 'paypal'].includes(res.paymenttype) ? 'flex' : 'none',
      recentchecked: ['creditcard', 'paypal'].includes(res.paymenttype) ? 'checked' : '',
      intro: I18n['payment_subscription_intro'],
      current_plan_label: I18n['payment_subscription_current_plan'],
      current_plan: planNames[res.current_plan],
      num_items_value: res.asset_count,
      num_alerts_value: res.alert_count,
      select_plan_label: I18n['payment_subscription_select_plan'],
      marker_free: res.current_plan === 'free' ? 'topup-plan-header--active' : '',
      marker_pay_per_asset: res.current_plan === 'basic' ? 'topup-plan-header--active' : '',
      marker_unlimited: res.current_plan === 'unlimited' ? 'topup-plan-header--active' : '',
      bx1: "document.querySelectorAll('.button_paymethod').forEach(function(el) { el.style.borderColor = ''; }); this.style.borderColor = '#2563eb';",
      credit_block_message: I18n['payment_subscription_credit_balance_blocked'],
      per_month: '/ month',
      free: {},
      basic: {
        code: 'basic', name: planNames.basic, price: findPlan('basic').price,
        price_label: formatPrice(findPlan('basic').price), blocked: findPlan('basic').blocked_by_credit_balance
      },
      unlimited: {
        code: 'unlimited', name: planNames.unlimited, price: findPlan('unlimited').price,
        price_label: formatPrice(findPlan('unlimited').price), blocked: findPlan('unlimited').blocked_by_credit_balance
      }
    };
    const compiled = _.template(window.template_payment_dialog)({ data: parseData });
    const dialogHtml = $.parseHTML(compiled);
    const buttons = [{ action: 'abort', title: I18n['payment_cc_cancel'] }, { action: 'save', title: I18n['payment_subscription_continue'] }];
    return wadialog(I18n['payment_dialog_header'], dialogHtml, buttons, settlePayment, payment_jscripts, res).then(build_paypal_interface);
  }).catch(function(err) {
    const message = err && err.responseJSON && err.responseJSON.error;
    alert(message || 'Sorry, could not execute a connection to our server');
  });
}

export function get_selected_item() {
  return $('.product-radio-button:checked').val() || null;
}

function isSelectedPlanBlocked() {
  return $('.product-radio-button:checked').attr('data-credit-blocked') === 'true';
}

export function enable_payment_dialog_btns() {
  if (get_selected_item() && !isSelectedPlanBlocked() && ($('#pay-paypal').is(':checked') || $('#pay-creditcard').is(':checked') || $('#pay-recent').is(':checked'))) {
    $('.dialog-btn.btn-success').removeClass('disable').prop('disabled', false).show();
  }
}

export function disable_payment_dialog_btns() {
  $('.dialog-btn.btn-success').addClass('disable').prop('disabled', true).hide();
}

export function hide_payment_dialog_btns() {
  $('.dialog-btn').addClass('disable').prop('disabled', true).hide();
}

export function payment_jscripts(obj) {
  obj.ready(function () {
    disable_payment_dialog_btns();
    $('#datepicker').datepicker({ minViewMode: 'months', maxViewMode: 'years', format: 'mm/yy' });
    $('.product-radio-button, .payment-radio-button').on('change', function() {
      const selected = $('.product-radio-button:checked');
      const hasPlan = selected.length > 0;
      const blocked = isSelectedPlanBlocked();
      const canPay = hasPlan && !blocked;
      $('#payment_credit_warning').toggle(hasPlan && blocked);
      $('#payment_method_selection').toggle(canPay);
      if (hasPlan) {
        const currencySymbol = selected.attr('data-currency').toCurrencySymbol();
        $('#payment_total_amount').text(currencySymbol + formatNumberForLocale(Number(selected.attr('data-price')).toFixed(2)));
        $('#payment_total').css('visibility', 'visible');
      }
      $('#amount_warning').css('max-height', hasPlan ? '0px' : '100px');
      $('#creditcard_form').css('max-height', canPay && $('#pay-creditcard').is(':checked') ? '490px' : '0px');
      $('#paypal_form').css('max-height', canPay && $('#pay-paypal').is(':checked') ? '190px' : '0px');
      disable_payment_dialog_btns();
      if (!$('#pay-paypal').is(':checked')) enable_payment_dialog_btns();
    });
  });
}

export function checkUserPaymentStatus() {
  return Boolean(creditpoints.accounttype) && creditpoints.canadditem === true;
}

export function settlePayment() {
  var method = 'none';
  if ($('#pay-paypal').is(':checked')) method = 'paypal';
  if ($('#pay-creditcard').is(':checked')) method = 'creditcard';
  if ($('#pay-recent').is(':checked')) method = 'recent';
  var plan = get_selected_item();
  if (!plan || !['creditcard', 'recent'].includes(method)) return;
  if ($('#product-' + plan).prop('disabled') || isSelectedPlanBlocked()) return;

  feedbackProcessingDialog();
  validatePaymentForm().then(function() {
    return getBraintreeClientToken();
  }).then(function(token) {
    return payment_tokenize(token, method);
  }).then(function(payload) {
    return subscribeWithPayment(method, payload, plan, 1);
  }).then(function(response) {
    killProcessingDialog();
    if (response && response.success) showPaymentSuccessful(response);
    else throw new Error('Payment failed');
  }).catch(function(error) {
    killProcessingDialog();
    showSubscriptionError(error);
  });
}

function showSubscriptionError(error) {
  const response = error && error.responseJSON;
  const message = response && response.code === 'credits_exceed_month_price'
    ? I18n['payment_subscription_credit_balance_blocked']
    : errorcodes['105'];
  $('.105').text(message).css('opacity', '1');
}

export function validatePaymentForm() {

  return new Promise(function (resolve, reject) {
    if ($('#pay-creditcard').prop('checked')) {
      var errors = 0;
      if (!validate_single_input($('#pay-cc-name'))) errors++;
      if (!validate_single_input($('#datepicker'))) errors++;
      if (!validate_single_input($('#pay-cc-number'))) errors++;
      if (!validate_single_input($('#pay-cc-cvv'))) errors++;
      if (!errors) {
        resolve();
        return true;
      } else {
        reject(errors);
        return false;
      }
    }
    else {
      resolve();
      return true;
    }
  });
}

export function showPaymentSuccessful(response) {
  $('.bootstrap-dialog-footer-buttons > .btn-success').hide();
  $('.bootstrap-dialog-footer-buttons > .modal-cancel-btn').text(I18n['payment_subscription_close']).removeClass('disable d-none').prop('disabled', false).show().off('click').on('click', function() {
    BootstrapDialog.closeAll();
    window.location.reload();
  });
  const messages = {
    created: I18n['payment_subscription_created'],
    updated: I18n['payment_subscription_updated'],
    upgraded: I18n['payment_subscription_upgraded'],
    downgrade_scheduled: I18n['payment_subscription_downgrade_scheduled']
  };
  let message = messages[response.outcome];
  const charged = Number(response.charged_amount);
  message += ' ' + (charged > 0
    ? __translate(I18n['payment_subscription_charged'], charged.toFixed(2) + ' ' + response.currency)
    : I18n['payment_subscription_no_charge']);
  if (response.cancellation_pending) message += ' ' + I18n['payment_subscription_cancellation_pending'];
  $('#paymentDialog').text(message);
}

export function build_paypal_interface() {
  // Create a client.
  getBraintreeClientToken().then(function(token) {
    // Create a client.
    braintree.client.create({
      authorization: token
    }, function (clientErr, clientInstance) {

      // Stop if there was a problem creating the client.
      // This could happen if there is a network error or if the authorization
      // is invalid.
      if (clientErr) {
        console.error('Error creating client:', clientErr);
        return;
      }

      // Create a PayPal Checkout component.
      braintree.paypalCheckout.create({
        client: clientInstance
      }, function (paypalCheckoutErr, paypalCheckoutInstance) {

        // Stop if there was a problem creating PayPal Checkout.
        // This could happen if there was a network error or if it's incorrectly
        // configured.
        if (paypalCheckoutErr) {
          console.error('Error creating PayPal Checkout:', paypalCheckoutErr);
          return;
        }
        
        const environment = clientInstance._configuration.gatewayConfiguration.environment;
        // Set up PayPal with the checkout.js library
        paypal.Button.render({
          env: environment,
          commit: true, // This will add the transaction amount to the PayPal button
          locale: I18n['paypal_locale'],
          style: {
              size: 'medium',
              color: 'gold',
              shape: 'pill',
              label: 'pay'
          },

          payment: function () {
            if (!get_selected_item()) throw new Error('Choose a plan first');
            if (isSelectedPlanBlocked()) throw new Error(I18n['payment_subscription_credit_balance_blocked']);
            return paypalCheckoutInstance.createPayment({ flow: 'vault' });
          },

          onAuthorize: function (data, actions) {
            feedbackProcessingDialog();
            return paypalCheckoutInstance.tokenizePayment(data, function (err, payload) {
              if (err) {
                killProcessingDialog();
                showSubscriptionError(err);
                return;
              }
              var plan = get_selected_item();
              subscribeWithPayment('paypal', payload.nonce, plan, 1).then(function(payment_res) {
                killProcessingDialog();
                if (payment_res && payment_res.success) showPaymentSuccessful(payment_res);
                else alert('Payment could not be completed');
              }).catch(function(err) {
                killProcessingDialog();
                showSubscriptionError(err);
              });
            });
          },

          onCancel: function (data) {
          },

          onError: function (err) {
          }
        }, '#paypal-button').then(function () {
          // The PayPal button will be rendered in an html element with the id
          // `paypal-button`. This function will be called when the PayPal button
          // is set up and ready to be used.
        });
      });
    });
  });
}

export function calcCostsBYQuantity(item_quantity,product_price_in_creditpoints) {
  var monthlycosts = product_price_in_creditpoints;
  if (monthlycosts && item_quantity * 31 > monthlycosts ) return monthlycosts/31;
  return item_quantity; 
}
